var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"details"},[_c('article',{staticClass:"details-card",staticStyle:{"margin-top":"32px"}},[_vm._m(0),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":[
        {
          label: 'ID',
          field: 'id',
          type: 'number',
        },
        {
          label: 'Cadastrado em',
          field: 'created_at',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD HH:mm:ss',
          dateOutputFormat: 'DD/MM/YY HH:mm',
        },
        {
          label: 'Nome',
          field: 'name',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'País',
          field: 'country',
        },
        {
          label: 'Saldo',
          field: 'balance',
          searchable: false,
          type: 'number',
        },
        {
          label: 'Ações',
          field: 'actions',
          sortable: false,
        } ],"rows":_vm.users,"search-options":{
        enabled: true,
        placeholder: 'Pesquisar',
      },"sort-options":{
        enabled: true,
        initialSortBy: {field: 'id', type: 'desc'}
      },"pagination-options":{
        enabled: true,
        mode: 'records',
        perPage: 20,
        position: 'top',
        perPageDropdown: [10, 20, 50, 100],
        dropdownAllowAll: false,
        setCurrentPage: 1,
        nextLabel: 'Próximo',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Resultados por página',
        ofLabel: 'of',
      }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'actions')?[_c('button',{on:{"click":function($event){$event.preventDefault();_vm.balance(props.row.id)}}},[_vm._v("Adicionar / Remover créditos")])]:[_vm._v("\n          "+_vm._s(props.formattedRow[props.column.field])+"\n        ")]]}}])})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"details-header"},[_c('h1',{staticClass:"details-header--title"},[_vm._v("Usuários")]),_vm._v(" "),_c('p',{staticClass:"details-header--date"},[_vm._v("Veja seus usuários e adicione ou remova saldo")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-204d5dd9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Admin.vue
// module id = 108
// module chunks = 0